<template>
  <div class="activiti-uploadFiles">
    <a-modal
      v-model="visible"
      title="上传流程文件"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
    >
      <div class="oa-app">
        <a-radio-group v-model="valueRadio" @change="onChangeRadio">
          <a-radio :value="0">通用</a-radio>
          <a-radio :value="1">指定部门</a-radio>
        </a-radio-group>
      </div>
      <div class="oa-app" v-show="isvalueRadio">
        <p>请选择审批流涉及部门：</p>
        <div>
          <a-tree-select
            v-model="departmentSelectData"
            class="w300"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="treeData"
            placeholder="请选择审批流涉及部门"
            tree-default-expand-all
            :replaceFields="replaceFields"
            @change="changeTreeData"
          >
          </a-tree-select>
        </div>
      </div>
      <div class="oa-app">
        <p>请选择审批流涉及业务：</p>
        <div>
          <a-select
            v-model="appSelectModel"
            placeholder="请选择审批流涉及业务"
            style="width: 200px"
          >
            <a-select-option
              v-for="item in appSelectData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.appName }}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="oa-app">
        <p>请上传审批流bpmn文件：</p>
        <div>
          <a-upload
            name="file"
            :multiple="false"
            action="#"
            :beforeUpload="beforeUpload"
            :fileList="dllFileList"
            @change="uploadFile"
          >
            <a-button class="ant-btn-upload">
              <a-icon type="upload" />
              上传文件
            </a-button>
          </a-upload>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  appList,
  applicationdetail,
  activitiTreeList,
  uploadStreamAndDeploymentFirst
} from '../api/api'
export default {
  props: ['isShow'],
  data() {
    return {
      confirmLoading: false,
      visible: false,
      checkboxGround: [],
      appSelectModel: [],
      appSelectData: [],
      departmentSelectData: [],
      dllFileList: [],
      treeData: [],
      replaceFields: {
        key: 'id',
        value: 'id',
        children: 'treeList',
        title: 'organizationName'
      },
      valueRadio: 0,
      isvalueRadio: false
    }
  },
  watch: {
    isShow(newVal, odlVal) {
      this.visible = newVal
    }
  },
  mounted() {
    this.appListFn()
    this.activitiTreeListFn()
  },
  methods: {
    changeTreeData(e) {
      //选择部门 获取当前部门下的应用
      applicationdetail({ id: e }).then((res) => {
        if (res.data.code === 0) {
          this.appSelectData = res.data.data
          this.appSelectModel = [] //清空已选择的应用
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // app业务列表
    appListFn() {
      appList().then((res) => {
        if (res.data.code === 0) {
          this.appSelectData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 审批部门组织树
    activitiTreeListFn() {
      activitiTreeList().then((res) => {
        if (res.data.code === 0) {
          this.treeData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onChangeRadio(e) {
      let key = e.target.value
      switch (key) {
        case 0:
          this.isvalueRadio = false
          this.departmentSelectData = [] //选择通用 清空选择的部门
          this.appListFn() // 重新拉应用列表
          break
        case 1:
          this.isvalueRadio = true

          break
        default:
          break
      }
    },
    // 取消按钮
    handleCancel() {
      this.$emit('isShowEmit', false)
    },
    // 确认按钮
    handleOk() {
      if (this.valueRadio === 0) {
        if (this.appSelectModel.length === 0 || this.dllFileList.length === 0) {
          this.$message.error('上传信息不能为空')
        } else {
          this.uploadStreamAndDeploymentFirstFn()
        }
      } else {
        if (
          this.appSelectModel.length === 0 ||
          this.departmentSelectData.length === 0 ||
          this.dllFileList.length === 0
        ) {
          this.$message.error('上传信息不能为空')
        } else {
          this.uploadStreamAndDeploymentFirstFn()
        }
      }
    },
    uploadStreamAndDeploymentFirstFn() {
      let formData = new FormData()
      formData.append('processFile', this.dllFileList[0].originFileObj)
      formData.append('appInfoId', this.appSelectModel)
      formData.append(
        'organizationId',
        this.valueRadio === 0 ? this.valueRadio : this.departmentSelectData
      )
      this.confirmLoading = true
      uploadStreamAndDeploymentFirst(formData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success('上传流程文件成功')
          this.$emit('isShowEmit', false)
          this.appSelectModel = []
          this.dllFileList = []
          this.valueRadio = 0
          this.departmentSelectData = [] //选择通用 清空选择的部门
          this.appListFn() // 重新拉应用列表
          this.isvalueRadio = false
          this.confirmLoading = false
        } else {
          this.confirmLoading = false
        }
      })
    },
    // 上传文件部分
    beforeUpload(file, fileList) {
      return false
    },
    uploadFile(info) {
      this.dllFileList = info.fileList
    }
  }
}
</script>

<style scoped>
.activiti-uploadFiles {
  height: auto;
  overflow: hidden;
}
.oa-app {
  height: auto;
  overflow: hidden;
  margin-bottom: 20px;
}
.oa-app-colorRed {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/system/activitiList/components/uploadfile-pop.vue